var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M6 2a1 1 0 0 0 0 2h7v17a1 1 0 1 0 2 0V4h7a1 1 0 1 0 0-2H6z"}}),_c('path',{attrs:{"d":"M1 9a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H7v11a1 1 0 1 1-2 0V10H2a1 1 0 0 1-1-1z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }